<div class="signup-header" [class.centered]="centered">
  <div class="d-flex align-items-start justify-content-between w-100">
    <img class="d-flex logo" ngSrc="/assets/ce-logo.svg" height="36" width="144" priority alt="" />
    @if (cancelable) {
      <div class="d-flex justify-content-center cancel-btn">
        <app-link-btn
          (click)="handleCancel()"
          label="Cancel"
          [active]="false"
          size="medium"
          IconType="cancel"
          [alert]="true"
          [disabled]="false"></app-link-btn>
        <!-- <app-secondary-btns label="Cancel & Go back" (onClick)="handleCancel()"></app-secondary-btns> -->
      </div>
    }
  </div>
  <div class="d-flex align-items-center spacing-12 white-space">
    <ng-content></ng-content>
  </div>
</div>
